import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function AuthorSection() {
  const revealRef = useScrollReveal();
  return <section className="bg-brand-dark bg-grain py-[60px] md:py-[100px] px-[5%]" data-id="element-14">
      <div ref={revealRef} className="max-w-[700px] mx-auto reveal text-center" data-id="element-15">
        <div className="font-body text-[11px] tracking-[0.15em] text-brand-gold uppercase mb-4" data-id="element-16">
          LA CREADORA DEL PROTOCOLO
        </div>

        <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-cream mb-8" data-id="element-17">
          La voz detrás de RENACER
        </h2>

        <div className="text-left max-w-[600px] mx-auto" data-id="element-18">
          <p className="font-body font-light text-[16px] leading-[1.8] text-brand-cream/70 mb-6" data-id="element-19">
            "RENACER no nació de una teoría. Nació de la noche más oscura — las
            3 de la mañana frente a un espejo, mirando a alguien que ya no
            reconocía."
          </p>
          <p className="font-body font-light text-[16px] leading-[1.8] text-brand-cream/70 mb-10" data-id="element-20">
            "De esa desesperación convertida en claridad emergió este protocolo.
            Lo que encontré es lo que hoy entrego en estas páginas."
          </p>

          <div className="border-l-[3px] border-brand-gold pl-6 py-2 mb-10" data-id="element-21">
            <p className="font-display italic text-[24px] text-brand-cream/90 leading-[1.4]" data-id="element-22">
              "No creé esto para enseñar. Lo creé para compartir lo que me
              salvó."
            </p>
          </div>
        </div>

        <div className="font-display italic text-[28px] text-brand-gold" data-id="element-23">
          Yajaira Mejías
        </div>
      </div>
    </section>;
}